import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yunying",
  "use": "icon-yunying-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yunying\"><path fill=\"#ffffff\" d=\"M856 735.1V177H534v-72.8h-46V177H168v558.1h320v31.4L367.3 887.3l32.5 32.5L511 808.5l111.3 111.3 32.5-32.5L534 766.5v-31.4h322zM214 223h596v466.1H214V223zM525.3 529.2l-10-10-109.7-109.7-136 136 32.5 32.5 103.5-103.5 51.7 51.8 68 68 227-227-32.5-32.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol